export default __webpack_public_path__ + "static/media/tick.78034e9c.svg";